import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["authUserTypes", "location"];
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, withRouter } from 'react-router-dom';
import { Authentication } from '@spm/core';
import TitledRoute from './TitledRoute';
import PATHS from './Paths';

/**
 * The AuthenticatedRoute component. See further documentation below.
 */
var AuthenticatedRoute = function AuthenticatedRoute(_ref) {
  var authUserTypes = _ref.authUserTypes,
    location = _ref.location,
    rest = _objectWithoutProperties(_ref, _excluded);
  return Authentication.userTypeIs(authUserTypes) ? /*#__PURE__*/React.createElement(TitledRoute, rest) : /*#__PURE__*/React.createElement(Redirect, {
    to: {
      pathname: PATHS.LOGIN,
      state: {
        redirectedFrom: location
      }
    }
  });
};
AuthenticatedRoute.propTypes = process.env.NODE_ENV !== "production" ? {
  authUserTypes: PropTypes.arrayOf(PropTypes.oneOf(_Object$keys(Authentication.USER_TYPES))).isRequired,
  location: PropTypes.object.isRequired,
  title: PropTypes.shape({
    defaultMessage: PropTypes.string,
    id: PropTypes.string
  }).isRequired
} : {};

/**
 * Handles the authorization of a page based on the specified user types that are passed
 * as an input prop. If the current user is authorized to access the requested page, then they
 * can access the page directly. Otherwise they will be redirected to the login page.
 *
 * @param {Array} authUserTypes The list of authentication user types. It is mandatory.
 * @param {string} title A react-intl message that will dynamically prefix the application title with the page title
 * in order to provide a meaningful page title. It is mandatory.
 *
 */
export default withRouter(AuthenticatedRoute);